import { BaseSpecialRenderer } from './base-special-renderer';
import { CaptchaRenderer } from './captcha-renderer';
import { GdprRenderer } from './gdpr-renderer';
import { AccountIdRenderer } from './account-id-renderer';

export type SpecialFieldType = 'captcha' | 'gdpr' | 'accountId';

export class SpecialRendererFactory {
    private renderers = new Map<SpecialFieldType, BaseSpecialRenderer>(
        [
            ['captcha', new CaptchaRenderer()],
            ['gdpr', new GdprRenderer()],
            ['accountId', new AccountIdRenderer()],
        ]
    );

    public getRenderer(type: SpecialFieldType): BaseSpecialRenderer {
        const renderer = this.renderers.get(type);
        if (!renderer) {
            throw new Error(`No renderer registered for special field type: ${type}`);
        }

        return renderer;
    }
}
